import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import { AreaChart as RechartsAreaChart, Area as RechartsArea, Legend as RechartsLegend, XAxis, YAxis, Brush, Tooltip as RechartsTooltip, CartesianGrid, ResponsiveContainer, } from 'recharts';
import { getColor, mapGridOptions } from './chartHelper';
import AreaGradient from './AreaGradient';
import ChartTooltip from './ChartTooltip';
const AreaChart = props => {
    const { width, height, data, dataUnit, dataKey, gradients, areas, xAxisOptions, yAxisOptions, gridOptions, showXAxis, showYAxis, showGrid, legend, brush, tooltip } = props, remainingProps = __rest(props, ["width", "height", "data", "dataUnit", "dataKey", "gradients", "areas", "xAxisOptions", "yAxisOptions", "gridOptions", "showXAxis", "showYAxis", "showGrid", "legend", "brush", "tooltip"]);
    const areasWithGradient = areas.map(area => {
        const _a = area.props, { strokeColor } = _a, remainingAreaProps = __rest(_a, ["strokeColor"]);
        const gradientId = area.key;
        const stroke = getColor(strokeColor);
        return {
            area: _createElement(RechartsArea, Object.assign({}, remainingAreaProps, { key: area.key, stroke: stroke, fill: `url(#${gradientId})` })),
            gradient: _jsx(AreaGradient, { id: gradientId, color: strokeColor }, area.key),
        };
    });
    return (_jsx(ResponsiveContainer, Object.assign({ width: '100%', height: '100%' }, { children: _jsxs(RechartsAreaChart, Object.assign({ width: width, height: height, data: data, margin: { top: 15, right: 15, left: 15, bottom: 15 } }, remainingProps, { children: [_jsxs("defs", { children: [gradients, areasWithGradient.map(areaWithGradient => areaWithGradient.gradient)] }), showGrid && _jsx(CartesianGrid, Object.assign({ strokeDasharray: '3 3' }, mapGridOptions(gridOptions))), _jsx(XAxis, Object.assign({ hide: !showXAxis, dataKey: dataKey }, xAxisOptions)), _jsx(YAxis, Object.assign({ hide: !showYAxis, unit: dataUnit }, yAxisOptions)), tooltip && _jsx(RechartsTooltip, Object.assign({}, tooltip.props)), legend && (_jsx(RechartsLegend, Object.assign({ wrapperStyle: legend.props.verticalAlign === 'bottom' ? { bottom: 0 } : legend.props.wrapperStyle }, legend.props))), areasWithGradient.map(areaWithGradient => areaWithGradient.area), brush && _jsx(Brush, { stroke: getColor('gray') })] })) })));
};
AreaChart.defaultProps = {
    width: 480,
    height: 200,
    data: [],
    dataUnit: '',
    // dataKey,
    gradients: [],
    areas: [],
    // xAxisOptions,
    // yAxisOptions,
    // gridOptions,
    showXAxis: true,
    showYAxis: false,
    showGrid: false,
    // legend,
    brush: false,
    tooltip: _jsx(ChartTooltip, {}),
};
export default AreaChart;
